import { render, staticRenderFns } from "./KnnTable.vue?vue&type=template&id=58bb58c8&lang=pug&"
import script from "./KnnTable.vue?vue&type=script&lang=ts&"
export * from "./KnnTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports